export function useSalesExpired() {
  return localStorage.getItem("salesExpire") === "1";
}
